<div *ngIf="disableBalanceView">
  <p class="text-left maintenance-text">undergoing scheduled maintenance</p>
</div>
<div class="summary" *ngIf="!disableBalanceView">
  <ng-container *ngIf="division === 'LEDGER'">
    <b>BDT {{ marginTradeTotal | number : 2 : true }}</b>
    <span class="signed-acc-types pr-0">
      <span> <i class="ind fas fa-user-tie"></i> </span>
      <span *ngIf="currentUser?.marginTradeDetails?.length > 1" class="position-relative">
        + <i class="far joint fa-handshake"></i>
        <span class="count">{{ currentUser?.marginTradeDetails?.length - 1 }}</span>
      </span></span>
  </ng-container>
  <ng-container *ngIf="division === 'CALS'">
    <b>BDT {{ calsTotal | number : 2 : true }}</b>
    <span class="signed-acc-types pr-0">
      <span> <i class="ind fas fa-user-tie"></i> </span>
      <span *ngIf="calsBalances?.length > 1" class="position-relative">
        + <i class="far joint fa-handshake"></i>
        <span class="count">{{ calsBalances?.length - 1 }}</span>
      </span></span>
  </ng-container>
  <ng-container *ngIf="division === 'CALI'">
    <b>BDT {{ caliTotal | number : 2 : true }}</b>
    <span class="signed-acc-types pr-0">
      <span> <i class="ind fas fa-user-tie"></i> </span>
      <span *ngIf="caliBalances?.length > 1" class="position-relative">
        + <i class="far joint fa-handshake"></i>
        <span class="count">{{ caliBalances?.length - 1 }}</span>
      </span></span>
  </ng-container>
</div>